define('views/filefinder/Podio.Views.FileFinderFileList',['require','translate','underscore','jquery','lib/jquery/jquery.podioCheckList','jquery.scrollTo','lib/backbone/Backbone.PodioView','lib/Podio.Transport','lib/Podio.Routes','lib/Podio.Browser','lib/Podio.UI','lib/Podio.Utils','jst!filefinder/_tab_filelist','jst!filefinder/_tab_error','jst!filefinder/_blankslate_search'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.podioCheckList');
  require('jquery.scrollTo');

  var PodioView = require('lib/backbone/Backbone.PodioView');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');
  var podioBrowser = require('lib/Podio.Browser');
  var podioUI = require('lib/Podio.UI');
  var keyCodes = podioUI.KeyCodes;
  var utils = require('lib/Podio.Utils');

  var jstTabFilelist = require('jst!filefinder/_tab_filelist');
  var jstTabError = require('jst!filefinder/_tab_error');
  var jstSearch = require('jst!filefinder/_blankslate_search');

  var fileFinderFileList = PodioView.extend({

    className: 'tab tab-file-list',

    podioEvents : {
      'click .connect-button'       : 'onConnectButtonClick',
      'click .try-again-button'     : 'onTryAgainButtonClick',
      'click .reconnect-button'     : 'onReconnectButtonClick',
      'keydown default .file-list'  : 'onFileListKeyDown'
    },

    initialize : function(options) {
      _.bindAll(this, 'render', 'renderFiles', 'renderWaiting', 'onConnectButtonClick', 'onFileListChanged', 'onFileListFolderClicked', 'onFilesError', 'onAccountsError', 'resetSelectionState', 'onFileListKeyDown', 'onFileListLimitReached', 'hideBlankslate', 'showBlankslate', 'abortSearch', 'onInputCleared');
      _.bindAll(this, 'prepareDataForChecklist', 'onFileSelectionStateReset');

      this._super();

      this.elmParent = options.elmParent;
      this.eventBridge = options.eventBridge;

      this.state = options.state;


      this.accounts = options.accounts;
      this.accounts.bind('reset', this.render);
      this.accounts.bind('podioError', this.onAccountsError);

      this.files = options.files;
      this.files.bind('reset', this.renderFiles);
      this.files.bind('podioError', this.onFilesError);

      this.account = options.account;
      this.providerName = options.providerName;
      this.fileType = 'external';

      this.hasOptions = options.hasOptions || false;
      this.hasRenderedFiles = false;

      this.selectedFiles = [];

      this.elm = $(this.el);
      this.elm.addClass('tab-{0}'.format(this.providerName));

      this.selectionLimit = options.selectionLimit;

    },


    showLoader : function() {
      this.elmListContainer.addClass('loading-overlay-small');
    },

    hideLoader : function() {
      this.elmListContainer.removeClass('loading-overlay-small');
    },

    clearErrors : function() {
      this.elm.removeClass('error center');
      this.elm.find('.message-wrapper').remove();
    },

    hideFileList : function() {
      this.elm.find('.file-list').addClass('hidden');
    },

    showFileList : function() {
      this.elm.find('.file-list').removeClass('hidden');
    },

    hideFileListContainer : function() {
      this.elm.find('.file-list .list-container').addClass('hidden');
    },

    showFileListContainer : function() {
      this.elm.find('.file-list .list-container').removeClass('hidden');
    },

    selectFileInList : function(elmFileList, elmItem) {
      elmItem.addClass('active').focus();
      elmItem.siblings().removeClass('active');


      // Bounding box
      var offsetLimitTop = elmFileList.offset().top;
      var offsetLimitBottom = offsetLimitTop + elmFileList.outerHeight();

      var itemOffsetTop = elmItem.offset().top;
      var itemOffsetBottom = itemOffsetTop + elmItem.outerHeight();

      // Scrolling
      if ( (itemOffsetBottom > offsetLimitBottom) || (itemOffsetTop < offsetLimitTop) ) {
        elmFileList.scrollTo(elmItem);
      }
    },

    prepareDataForChecklist: function() {
      // Google currently does not allow referncing top level folders, only sub
      var linkedAccountType = this.files.linked_account_type;

      var topLevelFolderMap = {
        'google': [
          '_all',
          '_root',
          '_recent',
          '_shared',
          '_starred'
        ],
        'sharefile': [
          'favorites',
          'allshared'
        ]
      };

      // Filter the shit
      var filteredData = this.files.map(function(item) {
        return (function() {
          var className = [];

          var isFolderAndCheckable = item.get('mimetype') === 'folder' && item.get('shareable') === true;

          if (_.contains(topLevelFolderMap[linkedAccountType], item.get('external_file_id'))) {
            isFolderAndCheckable = false;
          }

          var data = {
            'name'                : item.get('name'),
            'external_file_id'    : item.get('external_file_id'),
            'icon'                : item.get('icon'),
            'isCheckable'         : item.get('mimetype') !== 'folder',
            'isFolderAndCheckable': isFolderAndCheckable
          };


          if (item.get('mimetype') === 'folder' && item.get('id') !== 'parent-folder') {
            data.customRightContent = '<div class="folder-arrow-icon icon-16 icon-16-arrow-right-grey"></div>';
          }

          if (item.get('mimetype') === 'folder') {

            if (item.get('direction')) {
              className.push(item.get('direction'));
            } else {
              className.push('direction-left');
            }
          }

          data.className = className.join(' ');

          return data;
        })();
      });


      var checkedItemsState = {};
      _.each(this.selectedFiles, function(item) {
        checkedItemsState[item] = item;
      });

      return {
        data: filteredData,
        checked: checkedItemsState
      };

    },

    render : function() {
      var hasLinkedAccount = this.accounts.length > 0;

      this.elm.toggleClass('center', !hasLinkedAccount);

      this.elm.html(this.getTemplate(jstTabFilelist, {
        accounts              : this.accounts.getByProvider( this.providerName ),
        providerName          : this.providerName,
        hasLinkedAccount      : hasLinkedAccount,
        searchPlaceHolderText : t('Search {0} #filefinder').format( this.account.get('capability_names')['files'] ),
        connectButtonText     : t('Connect to {0} #filefinder').format( this.account.get('capability_names')['files'] )
      }));


      this.elm.appendTo(this.elmParent);

      this.elmListContainer = this.elm.find('.list-container');

      if ( hasLinkedAccount ) {
        this.showLoader();
      } else {
        this.hideLoader();
      }

      // This sets up the checklist so searches can be started immediately
      this.renderFilesList(true);

      return this;
    },

    renderWaiting : function() {
      this.render();
      this.showLoader();
    },

    renderError : function(message, errorCode, identifier) {
      this.clearErrors();
      this.hideFileList();

      this.hasRenderedFiles = false;

      var buttonText = t('Try again #filefinder');
      var buttonClass = 'try-again-button';

      if (_.isNull(errorCode) || errorCode.indexOf('invalid_grant') !== -1) {
        buttonText = t('Reconnect account #filefinder');
        buttonClass = 'reconnect-button';
      }

      if (errorCode === 'no_files_found') {
        buttonText = t('Refresh  #filefinder');
      }

      this.elm.addClass('error center');
      this.elm.append(this.getTemplate(jstTabError, {
        message    : message,
        identifier : identifier,
        showButton : true,
        buttonClass : buttonClass,
        buttonText : buttonText
      }));

      this.hideLoader();
    },

    renderFiles: function() {

      if (!this.files.length) {
        this.renderEmpty();
      } else {
        this.renderFilesList();
      }

    },

    showBlankslate : function() {
      this.hideFileListContainer();
      // Show blankslate message
      this.elm.addClass('error center');
      this.elm.append(this.getTemplate(jstSearch, {
        message : t('No files found #filefinder_serverside_search')
      }));

      // TODO: When clearing search field: Hide blankslate
    },

    hideBlankslate : function() {
      this.showFileListContainer();
      this.elm.find('.file-finder-blankslate').remove();
    },

    renderEmpty : function() {
      this.renderError( t('No files found matching your selection #filefinder') , 'no_files_found', 'files');
    },

    renderFilesList : function(emptyInit) {
      var self = this;

      // Dispose
      if (this.elmFileListFilterInput && this.elmFileListFilterInput.podioChecklist) {
        this.elmFileListFilterInput.podioChecklist('dispose');
      }

      // Prepare data for list
      var listData = this.prepareDataForChecklist();

      // Initialize check list
      this.elmFileListFilterInput = this.elm.find('.file-list-filter-input');
      var checkListSettings = {
        data        : listData.data,
        idKey       : 'external_file_id',
        checkedItems : listData.checked,
        firstElementTabIndex : 2,
        inviteLimit: this.selectionLimit,
        elmResultContainer : this.elmListContainer,
        customCheckbox : {
          checked: 'icon-16 icon-16-single-green-tick',
          open: 'icon-16 icon-16-checkbox-open'
        },
        templates: {
          list:  _.template('<ul class="podio-check-list podio-checkbox-list"><%-content%></ul>')
        },
        callbacks : {
          onCheck: this.onFileListChanged.curry('check'),
          onUncheck: this.onFileListChanged.curry('uncheck'),
          onNonCheckableClick : this.onFileListFolderClicked
        }
      };

      checkListSettings['searchEnabled'] = true;
      checkListSettings['cacheKeyPrefix'] = function() {
        return self.account.get('linked_account_id') + '|' + self.files.external_folder_id + '|';
      };
      checkListSettings['searchFunc'] = function(query, callback) {

        self.elmFileListFilterInput.addClass('loading-input');
        self.abortSearch();

        self.isSearching = true;

        var route = routes.index_files_linked_account_path(self.account.get('provider'), self.account.get('linked_account_id'), {
          'external_folder_id' : self.files.external_folder_id,
          'mime_types' : self.files.mime_types,
          'name' : query
        });

        self.currentSearchRequest = transport.getJSON(route, {}, function(responseData) {

          self.hideBlankslate();
          self.elmFileListFilterInput.removeClass('loading-input');

          var searchData = _.map(responseData.data.object, function(item) {
            // doing this twice because this is not extracted properly
            // old code <3
            var isFolderAndCheckable = item.mimetype === 'folder' && item.shareable === true;

            var preparedItem = {
              'name'                : item.name,
              'external_file_id'    : item.external_file_id,
              'icon'                : item.icon,
              'isCheckable'         : item.mimetype !== 'folder',
              isFolderAndCheckable: isFolderAndCheckable
            };
            if (item.mimetype === 'folder') {
              preparedItem.customRightContent = '<div class="folder-arrow-icon icon-16 icon-16-arrow-right-grey"></div>';
              preparedItem.className = 'direction-left';
            }

            return preparedItem;
          });

          self.isSearching = false;

          if (searchData.length > 0) {
            self.hideLoader();
            callback(searchData);
          }
          else {
            self.showBlankslate();
          }

        });
      };

      this.elmFileListFilterInput.podioChecklist(checkListSettings);

      this.elmFileListFilterInput.unbind('podio:checklist:checkLimitReached');
      this.elmFileListFilterInput.bind('podio:checklist:checkLimitReached', this.onFileListLimitReached);
      this.elmFileListFilterInput.unbind('podio:checklist:inputCleared');
      this.elmFileListFilterInput.bind('podio:checklist:inputCleared', this.onInputCleared);

      this.clearErrors();
      this.showFileList();

      // Toggle and focus
      if (!this.isSearching && !emptyInit) {
        this.hideLoader();
        this.elm.addClass('ready');
        this.hasRenderedFiles = true;
      }

      this.show();
    },

    onInputCleared : function() {
      this.onFileSelectionStateReset();
      this.hideBlankslate();
      this.abortSearch();
    },

    abortSearch : function() {
      if (this.currentSearchRequest) {
        this.currentSearchRequest.abort();
      }
    },

    hide : function() {
      this.elm.addClass('hidden');
    },

    show : function() {
      this.elm.removeClass('hidden');
      this.elm.removeClass('minimized');

      if ( this.elmFileListFilterInput && this.elmFileListFilterInput.length ) {
        this.elmFileListFilterInput.focus();
      }
    },

    dispose: function() {

      this.accounts.unbind();
      this.files.unbind();

      this.eventBridge.unbind();

      this.hasRenderedFiles = false;

      this.remove();
    },

    getFiles : function() {

      var dfd = new $.Deferred();
      var data = {
        'account'  : this.account,
        'provider' : this.providerName,
        'type'     : 'external',
        'ids'      : this.selectedFiles
      };

      dfd.resolve(data);

      return dfd;
    },

    // TODO: Redo below function entirely. It's only used for clearing selections on
    // single file uploads and can be made much simpler

    clearSelectionExceptFileId : function(externalFileId) {
      this.selectedFiles = [externalFileId];
      this.onFileSelectionStateReset();
    },

    clearSelection : function() {
      this.selectedFiles = [];
      this.onFileSelectionStateReset();
    },

    resetSelectionState : function() {
      this.selectedFiles = [];
    },

    onConnectButtonClick : function(elmTarget, e) {
      this.eventBridge.trigger('connectService', this.providerName);
    },

    onTryAgainButtonClick: function(elmTarget, e) {

      if (elmTarget.hasClass('files')) {
        this.eventBridge.trigger('refreshFiles', this.providerName);
      } else if (elmTarget.hasClass('accounts')) {
        this.eventBridge.trigger('refreshAccounts', this.providerName);
      }

    },

    onReconnectButtonClick: function(elmTarget, e) {
      this.eventBridge.trigger('connectService', this.providerName);
    },

    onFileListLimitReached : function(e, externalFileId) {
      this.eventBridge.trigger('fileListLimitReached', this.providerName, externalFileId);
    },

    onFileListChanged: function(type, key) {
      if (type === 'check') {
        this.selectedFiles.push(key);
        this.selectedFiles = _.uniq(this.selectedFiles);
      }
      else {
        this.selectedFiles = _.without(this.selectedFiles, key);
      }

      this.eventBridge.trigger('fileListChanged', this.providerName);
    },

    onFileListFolderClicked : function(folderId, elmTarget, e) {
      var elmRealTarget = $(e.target);
      if (elmRealTarget.is('input[type=checkbox]') && elmRealTarget.hasClass('checkbox-folder')) {
        if (elmRealTarget.is(':checked')) {
          this.selectedFiles.push(folderId);
          this.selectedFiles = _.uniq(this.selectedFiles);
        }
        else {
          this.selectedFiles = _.without(this.selectedFiles, folderId);
        }

        this.eventBridge.trigger('fileListChanged', this.providerName);

        return;
      }

      // no op if trying to navigate while folder is checked
      if (elmTarget.find('.checkbox-folder').is(':checked')) {
        return;
      }

      var self = this;

      function onTransitionEnd() {
        self.elmListContainer.addClass('loading-overlay-small');
        self.eventBridge.trigger('getFolder', self.providerName, self.files.linked_account_id , folderId);

        // Clear the search field.
        self.clearSearchField();
      }

      var elmCheckList = this.elm.find('.podio-check-list');
      elmCheckList.bind(podioBrowser.cssTransitionEndEvent, onTransitionEnd);

      if (elmTarget.hasClass('direction-left')) {
        elmCheckList.addClass('slide-left');
      } else {
        elmCheckList.addClass('slide-right');
      }
    },

    onFileListKeyDown : function(elmTarget, e) {

      var elmFileList = this.elm.find('.podio-check-list');
      var elmActiveItem = elmFileList.find('li.active');

      switch (e.keyCode) {

      case keyCodes.DownArrow:
      case keyCodes.UpArrow:

        if (e.keyCode === keyCodes.DownArrow) {
          elmActiveItem = elmActiveItem.length ? elmActiveItem.next() : elmFileList.find('li').first();
        } else {
          elmActiveItem = elmActiveItem.prev();
        }

        if (elmActiveItem.length) {
          this.selectFileInList(elmFileList, elmActiveItem);
        }

        return false;

      case keyCodes.Return:
      case keyCodes.Space:
      case keyCodes.RightArrow:

        if ( elmActiveItem.length ) {
          e.stopPropagation();
          e.preventDefault();

          elmActiveItem.click();
          return false;
        } else {
          return true;
        }

        break;

      case keyCodes.Esc:
        this.eventBridge.trigger('dispose');
        return false;

      case keyCodes.LeftArrow:

        if (this.files.external_folder_id !== 'all') {
          elmFileList.find('li').first().click();
          return false;
        }

      }


    },

    onFilesError: function(message, response, model, options) {

      if (!message) {
        message = t("Sorry, we couldn't load your files from {0} #filefinder").format( this.account.get('capability_names')['files'] );
      }

      this.renderError(message, response.error_code, 'files');
    },

    onAccountsError : function(message, response, model, options) {

      if (!message) {
        message = t("Sorry, we couldn't load your accounts for {0} #filefinder").format( this.account.get('capability_names')['files'] );
      }

      this.renderError(message, response.error_code, 'accounts');
    },

    clearSearchField: function() {
      if (this.elmFileListFilterInput && this.elmFileListFilterInput.podioChecklist) {
        this.elmFileListFilterInput.podioChecklist('clearSearchField');
      }
    },

    onFileSelectionStateReset: function() {

      // Prepare data for list
      var listData = this.prepareDataForChecklist();

      // Update list
      if ( this.hasRenderedFiles && this.elmFileListFilterInput.data('podioChecklist') ) {
        this.elmFileListFilterInput.podioChecklist('updateCheckedState', listData.checked, listData.data);
      }
    }

  });

  return fileFinderFileList;

});

